module.exports = function () {
  var targs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var help = '';
  var content = '';
  if (targs.help) {
    help = targs.help;
  }
  if (targs.content) {
    content = targs.content;
  }
  return "\n      <div class=\"tutorial-overlay\" id=\"tutorial-overlay\">\n\t<div class=\"help\">".concat(help, "</div>\n\t<div class=\"content\">").concat(content, "</div>\n      </div>\n  ");
};